var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61223 13.9317C9.72798 14.0475 9.91539 14.0392 10.0229 13.9179L15.8271 7.21523C16.0696 6.93687 16.0559 6.52071 15.794 6.25889L14.7412 5.20608C14.4794 4.94425 14.0632 4.93047 13.7849 5.17301L7.08218 10.98C6.95816 11.0875 6.95265 11.2749 7.0684 11.3906L9.61223 13.9317Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5311 10.9706L19.7151 13.5194C19.7503 13.5604 19.794 13.5934 19.8432 13.616C19.8923 13.6386 19.9457 13.6503 19.9998 13.6503C20.0539 13.6503 20.1074 13.6386 20.1565 13.616C20.2056 13.5934 20.2493 13.5604 20.2845 13.5194L22.4686 10.9706C22.677 10.7273 22.5042 10.3516 22.1839 10.3516H17.8151C17.4948 10.3516 17.322 10.7273 17.5311 10.9706Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23845 16.3474L5.29401 16.7001L5.7901 16.2041H7.65319C7.7276 16.2041 7.79926 16.1737 7.85162 16.1214L8.56268 15.4103C8.67292 15.3001 8.67292 15.1237 8.56268 15.0134L5.98578 12.4421C5.87554 12.3318 5.69915 12.3318 5.58891 12.4421L4.87785 13.1531C4.82549 13.2055 4.79517 13.2771 4.79517 13.3516V15.0989C4.79517 15.1733 4.76485 15.245 4.71249 15.2973L4.12545 15.8844C3.98214 16.0304 4.04277 16.2812 4.23845 16.3474Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2979 17.6016H2.70003C2.31419 17.6016 2 17.9158 2 18.3016C2 18.6874 2.31419 19.0016 2.70003 19.0016H15.2979C15.6838 19.0016 15.9979 18.6874 15.9979 18.3016C15.9979 17.9158 15.6865 17.6016 15.2979 17.6016Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/Highlight.43a8a699ccab2f061dc0e7407a70b2fa.svg";
export { ForwardRef as ReactComponent };